module.exports = __webpack_public_path__ + "img/avterracebox09.cbb8387a.jpg";